"use client";

// Envoltura del encabezado de la portada: lo esconde cuando hay sesión.
//
// La portada se arma en el servidor, así que su encabezado no puede saber si
// hay sesión. Sin esto, alguien que ya entró veía DOS barras encimadas y un
// botón de "Crear cuenta" cuando ya tiene cuenta. La navegación de quien está
// adentro la da NavSuperior.
//
// Arranca visible y se esconde al montar: al revés, el visitante sin cuenta
// —que es el que más importa en la portada— vería un parpadeo sin encabezado.
import { useEffect, useState } from "react";
import { hasSession } from "../lib/api";

export default function EncabezadoPublico({ children }: { children: React.ReactNode }) {
  const [conSesion, setConSesion] = useState(false);
  useEffect(() => setConSesion(hasSession()), []);
  if (conSesion) return null;
  return <>{children}</>;
}
